const TargetSvg = () => {
    return (
        <svg
            width="254"
            height="421"
            viewBox="0 0 254 421"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M-9.5332 158.174C-38.8225 187.463 -39.1391 234.634 -10.2403 263.533C18.6585 292.432 65.8293 292.115 95.1186 262.826C124.408 233.537 124.725 186.366 95.8257 157.467C66.9269 128.568 19.7561 128.885 -9.5332 158.174Z"
                fill="url(#paint0_linear_1058_39888)"
            />
            <circle
                cx="43.4999"
                cy="209.793"
                r="107.75"
                transform="rotate(135 43.4999 209.793)"
                stroke="url(#paint1_linear_1058_39888)"
                strokeWidth="2.5"
            />
            <circle
                cx="43.4998"
                cy="210.5"
                r="147.25"
                transform="rotate(135 43.4998 210.5)"
                stroke="url(#paint2_linear_1058_39888)"
                strokeWidth="2.5"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1058_39888"
                    x1="43.2371"
                    y1="135.994"
                    x2="44.237"
                    y2="284.98"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2684FF" />
                    <stop offset="1" stopColor="#0E64DF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1058_39888"
                    x1="141"
                    y1="128.793"
                    x2="23.9999"
                    y2="328.793"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1058_39888"
                    x1="43.4998"
                    y1="62"
                    x2="43.4998"
                    y2="359"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4C9AFF" />
                    <stop offset="1" stopColor="#9BB2D1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default TargetSvg;
